// 1. Döviz kuru
const exchangeRate = 55.7;  // TL → EUR kur

// KDV'si %10 olan ürünler (adında veya URL'sinde geçen). Diğerleri %20.
const KDV_10_URUNLER = [/crown[\s-]*tec/i, /denture[\s-]*tec/i];

// "1.234,56 ₺" ve "1,234.56 ₺" ikisini de okur
function parseTL(v) {
  let s = v.replace(/[^\d.,]/g, '');
  const lc = s.lastIndexOf(','), ld = s.lastIndexOf('.');
  if (lc > ld) {
    s = (ld === -1 && s.length - lc - 1 === 3)
      ? s.replace(/,/g, '')
      : s.replace(/\./g, '').replace(',', '.');
  } else {
    s = (lc === -1 && ld !== -1 && s.length - ld - 1 === 3)
      ? s.replace(/\./g, '')
      : s.replace(/,/g, '');
  }
  return parseFloat(s);
}

function kdvOrani(metin) {
  return KDV_10_URUNLER.some(r => r.test(metin || '')) ? 0.10 : 0.20;
}

// Fiyatın ait olduğu ürün kutusu: başka satış fiyatı içermeyen en geniş kapsayıcı
function urunKutusu(el) {
  let k = el;
  while (k.parentElement && k.parentElement !== document.body &&
         k.parentElement.querySelectorAll('sale-price').length <= 1) {
    k = k.parentElement;
  }
  return k;
}

// Fiyatın hangi ürüne ait olduğunu anlatan metin (URL + ad)
function urunMetni(el) {
  const k = urunKutusu(el);
  const urunSayfasi = location.pathname.includes('/products/');
  const baslik = document.querySelector('h1')?.textContent || '';

  // Ürün sayfasının ana fiyatı
  if (urunSayfasi && k.querySelector('h1')) return location.pathname + ' ' + baslik;

  // Ürün kartı (koleksiyon, öneriler, sepet)
  const link = k.querySelector('a[href*="/products/"]');
  if (link) return link.getAttribute('href') + ' ' + link.textContent;

  if (urunSayfasi) return location.pathname + ' ' + baslik;
  return k.textContent;
}

// 3. EUR fiyatını ekle
function addUSDPrice(el) {
  if (el.querySelector('.usd-price')) return;

  const priceTL = parseTL(el.textContent.trim());
  if (isNaN(priceTL) || !priceTL) return;

  const oran = kdvOrani(urunMetni(el));
  const eurNet = priceTL / exchangeRate / (1 + oran);

  const usdElement = document.createElement('div');
  usdElement.className = 'usd-price';
  usdElement.style.fontSize = '0.85em';
  usdElement.style.color = 'gray';
  usdElement.textContent = `${eurNet.toFixed(2)} EUR + KDV (%${Math.round(oran * 100)})`;

  el.appendChild(usdElement);
}

// 4. Gözlemci
function initUSDPrices() {
  document.querySelectorAll('sale-price, compare-at-price').forEach(el => addUSDPrice(el));

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches('sale-price, compare-at-price')) addUSDPrice(node);
        node.querySelectorAll?.('sale-price, compare-at-price')?.forEach(el => addUSDPrice(el));
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', initUSDPrices);
